import { EventEmitter, Injectable } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
  NonNullableFormBuilder,
} from '@angular/forms';
import { Observable, map, of, catchError, Subject } from 'rxjs';
import { BaseFpxDataService } from '../../models/data-service.model';
import { TNavigation } from '../../models/forms.model';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  constructor() {}

  dataAvailabilityCheck(
    mode:TNavigation,
    controlName:string,
    service: BaseFpxDataService<unknown>,
    subject: Subject<unknown>
  ): AsyncValidatorFn {
    console.log('Inside data availability check method');
    return (
      control: AbstractControl
    ):
      | Promise<ValidationErrors | null>
      | Observable<ValidationErrors | null> => {

        const key = control.parent?.value  || {};

      if (service.findByKey) {
        console.log('finding data for key',control.value);
        key[controlName]=control.value;
        return service
          .findByKey(key)()
          .pipe(
            map(
              (res: any) => {
                if(mode==='MODIFY' && !res) {
                  subject.next(null);
                  return {'data_not_available':true};
                }
                else
                if(mode==='ADD' && res) {
                  console.log('Response identified in ADD ',res);
                  subject.next(null);
                  return {'data_already_available':true};
                }
                subject.next(res);
                return null;
              },
              catchError(() => {
                return of({network_down:true});
              })
            )
          );
      } else {
        return of();
      }
    };
  }
}
